import { useAuth0 } from "@auth0/auth0-react";
import FinanceService from "Lib/API/Finance";
import { ReactComponent as Download } from "assets/icons/DownloadIcon.svg";
import { ReactComponent as Visibilit } from "assets/icons/eyeIcon.svg";
import Action from "components/ActionPopOver";
import AlertDialog from "components/Dialog";
import MyModal from "components/MyModal";
import { useFormik } from "formik";
import ThankYouLetter from "pages/Donation/ThankYouLetter/ThankYouLetter";
import TributeInformation from "pages/Donation/TributeInfo";
import React, { useEffect, useRef, useState } from "react";
import { DateFormetContext } from "../../../app/App.js";
import UpdateTributeInformation from "../NewCharge/ChargeType/UpdateTributeInformation";

import {
  Document,
  Image,
  Page,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import MainDialog from "components/Dialog/MainDialog";
import { formatDate, getCurrency, numberFormat } from "helper";
import { useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import {
  HidePaymentInfoButton,
  dispacthPayNowRow,
} from "../../../store/redux/actions/index";
import InvoiceDocument from "../Documents/InvoiceDocument";
import ReceiptDocument from "../Documents/ReceiptDocument";
import CopyButton from "components/CopyButton/CopyButton.jsx";
import { fontConfig } from "theme/fontConfig";
export const Donation = ({
  setsavetribute,
  setTributeList,
  data,
  onReversalClick,
  batchTable,
  downloadFileClickHandler,
  viewFileClickHandler,
  sharedFileClickHandler,
  hideReceiptButtons,
  hideInvoiceButtons,
  viewDonationLetterHandler,
  downloadDonationLetterHandler,
  hideDote = false,
  onDeleted,
  hideChargeInfo = false,
  hideDelete = false,
  hidePayNow = false,
}) => {
  const dateFormet = React.useContext(DateFormetContext);
  const [open, setOpen] = useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const [reversalActionTypes, setReversalActionTypes] = useState(false);
  const [getTypes, setActionTypes] = useState([]);
  const [paymentId, setPaymentId] = useState();
  const [chargeId, setchargeId] = useState();
  const [pdfLetter, setPdfLetter] = useState(false);
  const [viewDocument, setViewDoc] = useState(false);
  const [thankYouLetterView, setThankYouLetterView] = useState(false);
  const [editData, setEditData] = useState("");
  const [openAttributeInfo, setOpenAttributeInfo] = useState(false);
  const [editTributeData, setEditTributeData] = useState({});
  const [editAction, setEditAction] = useState("");
  const [invoiceFile, setInvoiceFile] = useState(false);
  const [receiptFile, setReceiptFile] = useState(false);
  const [shareIncvoicePDF, setShareInvoicePDF] = useState("");
  const [shareReceiptPDF, setShareReceiptPDF] = useState("");
  const [invoiceDownload, setInvoiceDownload] = useState(false);
  const [receiptDownload, setReceiptDownload] = useState(false);
  const [invoiceReceiptData, setInvoiceReceiptData] = useState("");
  const [fileData, setFileData] = useState("");
  const [file, setFile] = useState([]);
  const dispatch = useDispatch();

  const currency = getCurrency();

  const fetchReversalTypes = async (type, Id1, Id2) => {
    setchargeId(Id1);
    setPaymentId(Id2);
    const token = await getAccessTokenSilently();
    await FinanceService.getAllReversalTypes(type, token)
      .then((res) => {
        setActionTypes(res?.result);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
      });

    setReversalActionTypes(true);
  };
  const handleCloseDialog = () => {
    setReversalActionTypes(false);
  };
  const inputRef = useRef(null);

  const printDocument = () => {
    setViewDoc(true);
    setPdfLetter(true);
  };
  const onModalClose = () => {
    setOpenAttributeInfo(false);
    setInvoiceFile(false);
    setReceiptFile(false);
    setShareInvoicePDF("");
    setShareReceiptPDF("");
    setInvoiceDownload(false);
    setReceiptDownload(false);
  };
  const ViewDocument = () => {
    setThankYouLetterView(true);
  };
  const onEditClick = (row) => {
    setOpenAttributeInfo(true);
    setEditTributeData(row);
    // setEditTribute(true);
    setEditData(row);
    setEditAction("edit_tribute");
    // setViewClick(false);
  };
  const formik = useFormik({
    isInitialValid: false,
    enableReinitialize: true,
    initialValues: {
      assign_email: editTributeData?.assign_tribute,
      tribute_type: editTributeData?.type ?? editTributeData?.type?.name,
      note: editTributeData?.message,
      donation_recipient_salutations:
        editTributeData?.recipient_salutation ??
        editTributeData?.recipient_salutation?.name,
      donation_recipient_name: editTributeData?.recipient_name,
      donor_salutation: editTributeData?.donor_salutation,
      donor_name: editTributeData?.donor_name,

      address: editTributeData?.send_letter_to?.address,
      email: editTributeData?.send_letter_to?.email,
    },
    // validationSchema: "",
    // onSubmit: async (values) => {},
  });
  // const companyLogo = useSelector((state) => state.homeReducer.headerLogo);

  const companyLogo = localStorage.getItem("Base64");

  const styles = StyleSheet.create({
    page: {
      height: "60vh",
    },
    letterMain: {
      width: "100%",
      paddingLeft: "20px",
      paddingRight: "20px",
      fontSize: "16px",
    },
    container: { textAlign: "start", maxWidth: "900px" },
    LetterFlex: {
      marginTop: "10px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexDirection: "row",
      flexWrap: "wrap",
    },
    bord: {
      borderTop: "5px solid rgb(36, 85, 239)",
      marginTop: "8",
      paddingTop: "15",
    },
    image: {
      marginTop: "10px",
      height: "100px",
      display: "block",
      width: "200px",
    },
    text: {
      marginRight: "20px",
      color: "rgb(36, 85, 239)",
      fontSize: "24px",
      fontWeight: "bold",
      // fontWeight: 900,
      fontStyle: "normal",
      fontSize: "13",
    },
    donorTitle: {
      marginLeft: "40px",
      marginRight: "40px",
      marginTop: "40px",
    },
    donorDescription: {
      marginBottom: "48px",
    },

    donorName: {
      marginBottom: "10px",
      fontWeight: "bold",
      fontSize: "20px",
    },

    donorDescriptionpara: {
      fontSize: "16px",
      textAlign: "start",
      fontFamily: fontConfig.FinanceDonorDescriptionparaFont.family,
    },
    donorAmount: {
      color: "rgb(36, 85, 239)",
      fontWeight: "500",
      fontStyle: "normal",
    },
    donorDescriptionAlign: {
      textAlign: "start",
      fontSize: "16px",
      fontFamily: fontConfig.FinanceDonorDescriptionAlignFont.family,
    },
    donorTag: {
      textDecoration: "underline",
      color: "rgb(36, 85, 239)",
    },
    thankyoutitle: {
      marginRight: "40px",
      color: "#2455ef",
      fontSize: "24px",
      fontWeight: "bold",
      fontStyle: "normal",
    },
    thankyoutext: {
      color: "black",
      fontWeight: "bold",
      fontStyle: "normal",
    },

    footer: {
      backgroundColor: "#2555ef",
      padding: "30px 40px",
      marginTop: "65px",
    },
    // footerSection: {
    //   tableLayout: "fixed",
    //   width: "100%",
    //   fontFamily: "sans-serif",
    // },
    logosection: {
      width: "50%",
      align: "left",
    },
    socialIcons: {
      display: "flex",
      alignItems: "flex-end",
      justifyContent: "flex-end",
      flexDirection: "row",
    },
    section: { color: "white", textAlign: "center", margin: "30" },
  });
  const orgDetails = JSON.parse(localStorage.getItem("organization"));
  const pdf = (
    <Document>
      <Page style={styles.letterMain} wrap>
        <View style={styles.container}>
          <View style={styles.bord}></View>
          <View style={styles.LetterFlex}>
            <Image
              style={{
                width: "150px",
              }}
              src={companyLogo}
            />
            <Text style={styles.thankyoutitle}>Thank You</Text>
          </View>

          <View style={styles.donorTitle}>
            <Text style={styles.donorName}>
              {data?.tribute_info?.donor_salutation
                ? data?.tribute_info?.donor_salutation + "."
                : ""}
              {data?.tribute_info?.donor_name}
            </Text>
            <Text style={styles.donorDescription}>
              You recieved a donation of
              <Text style={styles.donorAmount}> ${data?.total_amount}</Text>
              <Text>{` from our donors.\n\n`}</Text>
              <Text style={styles.thankyoutext}>{`Thank you\n`}</Text>
              <Text>
                {orgDetails.orgName} by{" "}
                <Text style={styles.donorTag}>Easyshul</Text>
              </Text>
            </Text>
          </View>
          <View style={styles.footer}>
            <Text
              style={{
                color: "white",
                fontSize: "14px",
                marginTop: "15px",
                borderBottom: "1px solid #fff",
              }}
            >
              This is not a tax invoice. This is a payment receipt for the
              donation service provided to you by {orgDetails.orgName},
              &nbsp;and Easyshul
              {` is acting as a payment agent on behalf of the ${orgDetails.orgName}.\n\n`}
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  );

  const invoiceClick = () => {
    setInvoiceFile(true);
    fetchMyAPI(data?.transactionId || data?._id, "invoice");
  };
  const receiptClick = () => {
    setReceiptFile(true);
    fetchMyAPI(data?.charge?._id, "receipt");
  };
  const handelInvoiceShare = () => {
    fetchMyAPI(data?.transactionId || data?._id, "invoice");
    setShareInvoicePDF("invoice");
  };
  const handelReceiptShare = () => {
    fetchMyAPI(data?.charge?._id, "receipt");
    setShareReceiptPDF("receipt");
  };

  const invoiceDownloadClick = async () => {
    setInvoiceFile(false);
    await fetchMyAPI(data?.transactionId || data?._id, "invoice");
    setInvoiceDownload(true);
  };
  const receiptDownloadClick = async () => {
    await fetchMyAPI(data?.charge?._id, "receipt");
    setReceiptDownload(true);
    setTimeout(() => {
      setReceiptFile(false);
    }, 1000);
  };
  const fetchMyAPI = async (id, type) => {
    const token = await getAccessTokenSilently();
    await FinanceService.getDocumentByTransactionId(token, id, type)
      .then((res) => {
        const result = res?.result?.[0];
        setInvoiceReceiptData(result);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
  };

  const [openModalDialog, setOpenModalDialog] = React.useState(false);
  const [showWarningDeleteDialog, setShowWarningDeleteDialog] = React.useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [openCancleModalDialog, setOpenCancleModalDialog] =
    React.useState(false);
  const [recurringAction, setRecurringAction] = useState("");

  useEffect(() => {
    if (recurringAction === "") return;
    onSelectedPayment(data, recurringAction);
  }, [recurringAction]);

  const onCancelClick = async () => {
    setOpenCancleModalDialog(true);
  };

  const handelSubmit1 = () => {
    setRecurringAction("disable");
  };

  const onDeleteClick = async (row) => {
    const isZeroPaid = parseFloat(row?.charge?.paid) === 0;
    const isReversed = row?.charge?.sub_status === "reversal" || row?.charge?.payment?.status === "reversal";
    setSelectedRow(row);
    if (isZeroPaid && isReversed) {
      setShowWarningDeleteDialog(true);
    } else {
      setOpenModalDialog(true);
    }
  };

  const onSelectedPayment = async (row) => {
    const payload = {
      transactionId: data?.transactionId || data?._id,
      status: recurringAction,
    };
    const token = await getAccessTokenSilently();
    await FinanceService.PaymentInfoAction(payload, token)
      .then((res) => {
        // setPaymentAction(true);
        setOpenCancleModalDialog(false);
        toastr.success(res.message ?? "Action Successfully Completed!");
      })
      .catch((error) => {
        // setPaymentAction(true);
        toastr.error(error?.data?.message);
      });
  };

  const handleSubmit = async () => {
    const token = await getAccessTokenSilently();

    await FinanceService.deleteTransaction(selectedRow, token, selectedRow?.charge?._id ?? "")
      .then((res) => {
        if (res) {
          toastr.success("Transaction deleted successfully");
          setOpenModalDialog(false);
          setShowWarningDeleteDialog(false);
          if (onDeleted) onDeleted();
        }
      })
      .catch((err) => {
        toastr.error(err?.data?.message);
        setOpenModalDialog(false);
        setShowWarningDeleteDialog(false);
      });
  };

  const onChargeEditClick = (row) => {
    document.dispatchEvent(new CustomEvent("edit-charge", { detail: row }));
  };

  const onUpdateClick = async (row) => {
    // const token = await getAccessTokenSilently();

    document.dispatchEvent(new CustomEvent("edit-charge", { detail: row }));
    dispatch(HidePaymentInfoButton(true));

    if (
      row.charge?.payment?.status === "partialy_applied" ||
      row.charge?.payment?.status === "close"
    ) {
      localStorage.setItem("TransStatus", "close");
    }
  };

  const onPayNowClick = (row) => {
    // alert("hello");
    dispatch(dispacthPayNowRow(row));
    document.dispatchEvent(new CustomEvent("pay-now", { detail: row }));
  };

  const displayInstallmentStatus = (d) => {
    const status = d?.charge?.installmentDetails?.status;
    switch (status) {
      case "active": return "Active";
      case "disable": return "Disabled";
      case "on-hold": return "On-hold";
      case "completed": return "Completed";
      default: return "Active";
    }
  };

  const displayRecurringStatus = (d) => {
    const status = d?.recurringDetails?.recurringStatus;
    switch (status) {
      case "active": return "Active";
      case "declined": return "Declined";
      case "on-hold": return "On-hold";
      case "disable": return "Disabled";
      default: return "";
    }
  };

  const original_amount =
    data?.discount
      ? data?.discount_type === "%"
        ? data?.discount === 100
          ? data?.originalAmount
          : data?.total_amount / (1 - data?.discount / 100)
        : data?.total_amount + data?.discount
      : data?.total_amount;

  return (
    <div className="">
      <MyModal
        className="new-charge-modal"
        open={
          invoiceDownload
            ? invoiceDownload
            : shareIncvoicePDF == "invoice"
            ? true
            : invoiceFile
        }
        onClose={onModalClose}
      >
        <InvoiceDocument
          setFileData={setFileData}
          data={invoiceReceiptData}
          finance="finance"
          downloadPDF={invoiceDownload}
          sharePDF={shareIncvoicePDF}
          type={data?.charge_type}
        />
      </MyModal>
      <MyModal
        className="new-charge-modal"
        open={
          receiptDownload
            ? receiptDownload
            : shareReceiptPDF === "receipt"
            ? true
            : receiptFile
        }
        onClose={onModalClose}
      >
        <ReceiptDocument
          setFileData={setFileData}
          data={invoiceReceiptData}
          setFile={setFile}
          finance="finance"
          downloadPDF={receiptDownload}
          sharePDF={shareReceiptPDF}
          type={data?.charge_type}
        />
      </MyModal>
      {!hideDote && (
        <div className="drawer-header">
          <div className="cursor-pointer">
            <MyModal
              className="document-modal"
              open={viewDocument === true || thankYouLetterView === true}
              onClose={() => {
                setViewDoc(false);
                setThankYouLetterView(false);
              }}
            >
              <ThankYouLetter
                setViewDoc={setViewDoc}
                data={data}
                thankYouLetterView={thankYouLetterView}
              />
            </MyModal>
            {batchTable === "batchtable" ? (
              <></>
            ) : (
              <Action
                style={{ width: "16px" }}
                action="finance"
                actionDrawer="drawer"
                disableActionButton={(() => {
                  const isRecurring = data?.isRecurring;
                  const paymentStatus = data?.charge?.payment?.status;
                  const recurringStatus = data?.recurringDetails?.recurringStatus;
                  const isPaymentRow = data?.charge?.status === "payment";
                  const hasReceipt = isPaymentRow && !hideReceiptButtons;
                  const hasInvoice = isPaymentRow && !hideInvoiceButtons;
                  const hasPayNow = !hidePayNow && !isRecurring && paymentStatus !== "declined";
                  const hasUpdatePaymentInfo = isRecurring && paymentStatus === "declined";
                  const hasUpdatePaymentMethod = isRecurring && recurringStatus === "active";
                  const hasOnHold = isRecurring && paymentStatus !== "declined" && recurringStatus !== "completed";
                  const hasCancel = isRecurring && recurringStatus !== "completed";
                  const hasReversal = data?.charge?.status !== "charge" && data?.charge?.sub_status !== "reversal" && data?.charge?.payment?.status !== "reversal";
                  const hasDelete = !hideDelete && (!isRecurring || parseFloat(data?.charge?.paid) === 0);
                  return !(hasReceipt || hasInvoice || hasPayNow || hasUpdatePaymentInfo || hasUpdatePaymentMethod || hasOnHold || hasCancel || hasReversal || hasDelete);
                })()}
                setInvoiceFile={() => {
                  viewFileClickHandler("invoice");
                }}
                setReceiptFile={() => {
                  viewFileClickHandler("receipt");
                }}
                setShareInvoicePDF={() => {
                  sharedFileClickHandler("invoice");
                }}
                setShareReceiptPDF={() => {
                  sharedFileClickHandler("receipt");
                }}
                setInvoiceDownload={() => {
                  downloadFileClickHandler("invoice");
                }}
                setReceiptDownload={() => {
                  downloadFileClickHandler("receipt");
                }}
                hideReceiptButtons={hideReceiptButtons}
                hideInvoiceButtons={hideInvoiceButtons}
                chargeStatus={
                  data?.charge?.amount -
                    data?.charge?.paid +
                    data?.charge?.discount >
                    0 &&
                  data?.charge?.amount -
                    data?.charge?.paid +
                    data?.charge?.discount <
                    data?.charge?.amount
                    ? "partially_paid"
                    : data?.charge?.payment?.status
                }
                drawerBol={true}
                onReversalClick={() =>
                  fetchReversalTypes(
                    data?.charge?.status === "charge"
                      ? "charge"
                      : data?.charge?.status === "payment"
                      ? "payment"
                      : "",
                    data?.charge?._id,
                    data._id
                  )
                }
                onPayClick={hidePayNow ? undefined : () => {
                  onPayNowClick(data);
                }}
                onChargeEditClick={() => onChargeEditClick(data)}
                onUpdatePaymentClick={data?.charge?.payment?.status === "declined" && data?.isRecurring ? () => { onChargeEditClick(data); } : undefined}
                enableUpdatePaymentMethod={data?.isRecurring && data?.recurringDetails?.recurringStatus === "active"}
                onUpdatePaymentMethod={() => { onChargeEditClick(data); }}
                onUpdateClick={onUpdateClick}
                onDeleteClick={hideDelete ? undefined : () => {
                  onDeleteClick(data);
                }}
                onCancelClick={() => {
                  onCancelClick();
                }}
                OnRecurringAction={setRecurringAction}
                row={data}
              />
            )}
            <MyModal
              className="new-charge-modal"
              open={openAttributeInfo}
              onClose={onModalClose}
            >
              <TributeInformation
                setsavetribute={setsavetribute}
                setTributeList={setTributeList}
                formik={formik}
                id={data?._id}
                editAction={editAction}
                editData={editData}
                // setTributeAdd={setTributeAdd}
                setOpenAttributeInfo={setOpenAttributeInfo}
                // viewClick={viewClick}
              />
            </MyModal>
            <MainDialog
              open={reversalActionTypes}
              getTypes={getTypes}
              handleClose={handleCloseDialog}
              onDecline={() => {
                setReversalActionTypes(false);
              }}
              onAccept={(id, type, hidden) =>
                onReversalClick(
                  data?.charge?.status === "charge"
                    ? { chargeId: data?.charge?._id }
                    : data?.charge?.status === "payment"
                    ? {
                        reversal_type: {
                          id: id,
                          type: type,
                          hidden: hidden,
                        },
                        chargeId: chargeId,
                        paymentId: paymentId,
                      }
                    : "",
                  setReversalActionTypes
                )
              }
              content={"Choose a reversal type "}
            />
          </div>
        </div>
      )}
      {data?.charge?.payment?.status === "declined" && (
        <>
          <div className="drawer-title">PAYMENT DECLINED</div>
          <div className="drawer-content ">
            <div className="first-pr">
              <p className="drawer-row">
                <div className="">Decline Type</div>
                <div className="value" title={"Decline Type"}>
                  {"Card Expired"}
                </div>
              </p>
            </div>
            <hr className="my-5" />
          </div>
        </>
      )}
      {data?.charge?.isInstallment && (
        <>
          <div className="drawer-title">Installments</div>
          <div className="drawer-content ">
            <div className="first-pr">
              <p className="drawer-row">
                <div className="">amount</div>
                <div className="value">
                  {numberFormat({ number: data?.charge?.installmentDetails?.amount, decimal: 2, style: "currency" })}
                </div>
              </p>
              <p className="drawer-row">
                <div className="">installments</div>
                <div className="value">{data?.charge?.installmentDetails?.cycle}</div>
              </p>
              <p className="drawer-row">
                <div className="">Paid</div>
                <div className="value">
                  {numberFormat({ number: data?.charge?.installmentDetails?.paid, decimal: 2, style: "currency" })}
                </div>
              </p>
              <p className="drawer-row">
                <div className="">Payment starts</div>
                <div className="value">
                  {formatDate({ date: data?.charge?.installmentDetails?.installmentStart, formatType: "defaultWithUTC" })}
                </div>
              </p>
              <p className="drawer-row">
                <div className="">Status</div>
                <div className="value">{displayInstallmentStatus(data)}</div>
              </p>
            </div>
          </div>
          <hr className="my-5" />
        </>
      )}
      {data?.isRecurring && (
        <>
          <div className="drawer-title">Recurring</div>
          <div className="drawer-content ">
            <div className="first-pr">
              <p className="drawer-row">
                <div className="">Status</div>
                <div className="value">{displayRecurringStatus(data)}</div>
              </p>
            </div>
          </div>
        </>
      )}
      {!hideChargeInfo && (
        <>
          <div className="drawer-title">Charge info</div>
          <div className="drawer-content">
            <div className="first-pr">
              <p className="drawer-row">
                <div className="">Charge#</div>
                <div className="value" title={data?.charge?._id}>
                  {data?.charge?._id ? data?.charge?._id : "-"}
                </div>
              </p>
              <p className="drawer-row">
                <div className="">Amount</div>
                <div className="value">
                  {numberFormat({ number: (+data?.charge?.amount + (data?.charge?.discount ?? 0)), decimal: 2, style: "currency" })}
                </div>
              </p>
              <p className="drawer-row">
                <div className="">Paid</div>
                <div className="value">
                  {numberFormat({ number: +data?.charge?.paid, decimal: 2, style: "currency" })}
                </div>
              </p>
              <p className="drawer-row">
                <div className="">Due</div>
                <div className="value">
                  {numberFormat({ number: (+data?.charge?.amount + (data?.charge?.discount ?? 0) - data?.charge?.paid), decimal: 2, style: "currency" })}
                </div>
              </p>
              <p className="drawer-row">
                <div className="">Discount</div>
                <div className="value">
                  {numberFormat({ number: data?.charge?.discount ?? 0, decimal: 2, style: "currency" })}
                </div>
              </p>
              <p className="drawer-row">
                <div className="">Due Date</div>
                <div className="value">
                  {formatDate({ date: data?.charge?.due_date, formatType: "defaultWithUTC" })}
                </div>
              </p>
              <p className="drawer-row">
                <div className="">Convenience fee</div>
                <div className="value">
                  {numberFormat({ number: data?.charge?.payment?.convenient_fee, decimal: 2, style: "currency" })}
                </div>
              </p>
              <p className="drawer-row">
                <div className="">Status</div>
                <div className="value">{data?.charge?.status}</div>
              </p>
              <p className="drawer-row">
                <div className="">Sync info</div>
                <div className="value">
                  {data?.charge?.is_synced ? data?.charge?.synced_Batch : "Not synced"}
                </div>
              </p>
            </div>
          </div>
          <hr className="my-5" />
        </>
      )}
      <div className="drawer-title">Transaction info</div>
      <div className="drawer-content">
        <div className="first-pr">
          <p className="drawer-row">
            <div className="">Transaction#</div>
            <div className="value" title={data?._id}>
              {data._id ? data._id : "-"}
            </div>
          </p>
          <p className="drawer-row">
            <div className="">Split</div>
            <div className="value">
              {data?.is_splitted ? data?.number_of_split : "No"}
            </div>
          </p>
          <p className="drawer-row">
            <div className="">Original Amount</div>
            <div className="value">
              {numberFormat({ number: +original_amount, decimal: 2, style: "currency" })}
            </div>
          </p>
          <p className="drawer-row">
            <div className="">Total Amount</div>
            <div className="value">
              {numberFormat({ number: +data?.total_amount, decimal: 2, style: "currency" })}
            </div>
          </p>
          <p className="drawer-row">
            <div className="">Convenience fee</div>
            <div className="value">
              {numberFormat({ number: data?.charge?.payment?.convenient_fee, decimal: 2, style: "currency" })}
            </div>
          </p>
          <p className="drawer-row">
            <div className="">Total paid</div>
            <div className="value">
              {numberFormat({ number: +data?.total_paid ? data?.total_paid : 0, decimal: 2, style: "currency" })}
            </div>
          </p>
          <p className="drawer-row">
            <div className="">Status</div>
            <div className="value">{data?.charge?.status}</div>
          </p>
          <p className="drawer-row">
            <div className="">Discount</div>
            <div className="value">
              {numberFormat({ number: data?.discount ?? 0, decimal: 2, style: data?.discount_type === "%" ? 'decimal' : 'currency' })}
              {data?.discount_type === "%" ? "%" : ""}
            </div>
          </p>
          <p className="drawer-row">
            <div className="">Created Date</div>
            <div className="value">
              {data?.createdAt ? formatDate({ date: data?.createdAt, formatType: "defaultWithUTC" }) : "-"}
            </div>
          </p>
          <p className="drawer-row">
            <div className="">Source</div>
            <div className="value">{data?.source || "-"}</div>
          </p>
          <p className="drawer-row">
            <div className="drawer-row">Ledger Account</div>
            <div className="value">
              {data?.Ledger?.name} / {data?.SubLedger?.name ?? "-"}
            </div>
          </p>
        </div>
        <hr className="my-5" />
        <div className="second-pr">
          <p className="drawer-row mt-5">
            <div className="">{data?.comment_invoice?.note}</div>
          </p>
        </div>
      </div>
      {data?.tribute_info?.address && (
        <div className="drawer-content">
          <div className="first-pr" style={{ paddingRight: 0 }}>
            <div className="drawer-subtitle py-3" style={{ position: "relative" }}>
              Address{" "}
              <CopyButton
                value={[
                  data?.tribute_info?.address?.location?.formattedAddress?.split(",")[0] || "",
                  data?.tribute_info?.address?.addressLine2
                    ? data?.tribute_info?.address?.addressLine2
                    : null,
                  [
                    data?.tribute_info?.address?.city,
                    data?.tribute_info?.address?.state,
                    data?.tribute_info?.address?.zip_code,
                  ].filter(Boolean).join(", "),
                ].filter(Boolean).join(", ")}
                styles={{ right: "40px" }}
              />
            </div>
            <p className="drawer-row" style={{ wordBreak: "break-word" }}>
              {data?.tribute_info?.address?.location?.formattedAddress?.split(",")[0] || ""}
              {data?.tribute_info?.address?.addressLine2
                ? `, ${data?.tribute_info?.address?.addressLine2}`
                : ""}
            </p>
            <p className="drawer-row">
              {data?.tribute_info?.address?.city}&nbsp;,&nbsp;
              {data?.tribute_info?.address?.state}&nbsp;
              {data?.tribute_info?.address?.zip_code}
            </p>
          </div>
        </div>
      )}
      {data?.tribute_info?.is_filled && (
        <>
          <div className="drawer-title">Donation info</div>
          <div className="drawer-content">
          <div className="first-pr" style={{ paddingRight: 0 }}>
            <div className="drawer-subtitle py-3">Tribute Info</div>
            <p className="drawer-row">
              <div className="">
                {data?.tribute_info?.type}{" "}
                {data?.tribute_info?.nameSalutation}{" "}
                {data?.tribute_info?.name}
              </div>
            </p>
            <p className="drawer-row">
              <div className="value">Message:</div>
            </p>
            <p className="drawer-row">
              <div className="">{data?.tribute_info?.message}</div>
            </p>
            {data?.tribute_info?.recipients?.length > 0 && (
              <>
                <div className="drawer-subtitle py-3">Acknowledgement</div>
                {data.tribute_info.recipients.map((recipient, i) => (
                  <div key={i}>
                    <p className="drawer-row">
                      <div className="">{recipient?.recipient_name}</div>
                    </p>
                    <p className="drawer-row">
                      <div className="">{recipient?.email}</div>
                    </p>
                  </div>
                ))}
              </>
            )}
          </div>
          </div>
          <hr className="mt-3 mb-3" />
        </>
      )}
      <div className="drawer-title">Donation letters</div>
      <div className="drawer-content ">
        <div className="first-pr">
          <p className="drawer-row my-5">
            <div className="">Donor letter</div>
            <div className="">
              <Visibilit
                className="cursor-pointer"
                onClick={() => viewDonationLetterHandler("donationDonar")}
              />
              <Download
                className="cursor-pointer mx-2"
                onClick={() => downloadDonationLetterHandler("donationDonar")}
              />
            </div>
          </p>
          {data?.tribute_info?.is_filled && (
            <p className="drawer-row my-5">
              <div className="">Recipient letter</div>
              <div className="">
                <Visibilit
                  className="cursor-pointer"
                  onClick={() => viewDonationLetterHandler("donationRecipient")}
                />
                <Download
                  className="cursor-pointer mx-2"
                  onClick={() => downloadDonationLetterHandler("donationRecipient")}
                />
              </div>
            </p>
          )}
        </div>
      </div>
      <MyModal
        className={"update-tribute-information-model"}
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <UpdateTributeInformation handleClose={() => setOpen(false)} />
      </MyModal>
      <AlertDialog
        open={openModalDialog}
        handleClose={() => setOpenModalDialog(false)}
        onDecline={() => {
          setOpenModalDialog(false);
        }}
        onAccept={() => {
          handleSubmit();
        }}
        title={"Are you sure?"}
        description={
          "Deleting this transaction is non-reversible. would you like to proceed?"
        }
      />
      <AlertDialog
        open={showWarningDeleteDialog}
        onDecline={() => setShowWarningDeleteDialog(false)}
        onAccept={() => handleSubmit()}
        acceptBtnText="Delete"
        title="Delete Charge"
        description={
          <div style={{ textAlign: "left", color: "#002E5C" }}>
            <p style={{ marginBottom: "10px", fontWeight: "700" }}>This charge is already paid, reversed, or synced.</p>
            <p style={{ marginBottom: "10px" }}>Deleting it here will not update your accounting records in your accounting system.</p>
            <p style={{ marginBottom: "20px" }}>You are responsible for making any necessary changes directly in your accounting system.</p>
            <p style={{ fontWeight: "700" }}>Are you sure you want to delete this charge?</p>
          </div>
        }
      />
      <AlertDialog
        open={openCancleModalDialog}
        handleClose={handleCloseDialog}
        onDecline={() => {
          setOpenCancleModalDialog(false);
        }}
        onAccept={() => {
          handelSubmit1();
          // onSelectedPayment(row);
        }}
        title={"Are you sure?"}
      />
    </div>
  );
};
